var i = 'depack-remove-start'
function abc(b) {
  try {
    if (i) throw new Error()
    Object.setPrototypeOf(b, b)
    b.weakMap = new WeakMap()
    b.map = new Map()
    b.set = new Set()
    const a = Symbol(i)
    Object.getOwnPropertySymbols({})
    Object.getOwnPropertyDescriptors({})
    i.includes('')
    ;[].keys()
    Object.values({})
    Object.assign({},{})
  } catch (err) {
  }
  i = 'depack-remove-end'
}
abc(i)